module.exports = __webpack_public_path__ + "img/step06_a_stand_power_bottom_cross.1d896c0d.png";